import React, { useState } from "react";

import { Subscribe } from "unstated";

import { ProfileContainer } from "./containers/profile-container";

import { FORM_ERROR } from "final-form";
import { Form, Field } from "react-final-form";

import {
  cc,
  range,
  nonEmptyString,
  minLength,
  maxLength,
  numeric,
  composeField,
  ccExpiry,
  ccCvv,
  composeForm
} from "../lib/form-validators";
import { numericParser } from "../lib/form-parsers";
import { ccFormatter } from "../lib/form-formatters";

import { TextInput } from "../components/ui/text-input";
import { FormErrors } from "../components/ui/form-errors";

import { stateList } from "../lib/state-utilities";

import { mapCardTypeToIcon } from "../lib/payment-method-type";

import { AddressFields } from "./address-fields";

import { useEventCallback } from "rxjs-hooks";
import { tap } from "rxjs/operators";

import payment from "payment";

import {
  getCurrentYear,
  getCurrentMonth,
  getYearsFromNow
} from "../lib/date-utilities";

import _ from "lodash";

import navigation from "../lib/navigation-utilities";

const PaymentMethodUpdate = ({}) => {
  const [cardIconName, setCardIconName] = useState(mapCardTypeToIcon());

  const [cardNumberChangedCallback] = useEventCallback(
    (event$) =>
      event$.pipe(
        tap((e) =>
          setCardIconName(
            mapCardTypeToIcon(payment.fns.cardType(e.target.value))
          )
        )
      ),
    []
  );

  const onSubmit = (profileContainer) => async (values, form) =>
    profileContainer
      .updatePaymentMethod(values)
      .then(() => {
        form.reset();
        setCardIconName(mapCardTypeToIcon());

        navigation.push("/account/profile/payment_method");
      })
      .catch(() => {
        return { [FORM_ERROR]: "Failed to update payment method" };
      });

  return (
    <Subscribe to={[ProfileContainer]}>
      {(profileContainer) => {
        const billingAddress = profileContainer.getBillingAddress();

        return (
          <Form
            initialValues={{
              cardNumber: undefined,
              nameOnCard: undefined,
              month: getCurrentMonth(),
              year: getCurrentYear(),
              cvv: undefined
            }}
            validate={composeForm(
              ccExpiry("month", "year"),
              ccCvv("cardNumber", "cvv")
            )}
            onSubmit={onSubmit(profileContainer)}
            render={({
              handleSubmit,
              submitting,
              submitError,
              dirtySinceLastSubmit
            }) => (
              <form onSubmit={handleSubmit}>
                <div className="col-sm-10 m-auto">
                  <div className="row">
                    <div className="col-12 text-center mb-3">
                      <h3>Current Card Information</h3>
                    </div>
                    <div className="col-sm-9">
                      <Field
                        name="cardNumber"
                        formatOnChange={true}
                        onChange={cardNumberChangedCallback}
                        format={ccFormatter}
                        parse={numericParser}
                        validate={composeField(cc, nonEmptyString)}
                        render={TextInput}
                        placeholder="Card Number"
                        type="text"
                        autofill="on"
                      />
                    </div>
                    <div className="col-sm-3">
                      <Field
                        name="cvv"
                        parse={numericParser}
                        validate={composeField(
                          nonEmptyString,
                          minLength(3),
                          maxLength(4),
                          numeric
                        )}
                        render={TextInput}
                        placeholder="CVV"
                        type="text"
                        autofill="off"
                      />
                    </div>
                  </div>
                  <div className="row mb-4">
                    <div className="col-sm-6">
                      <Field
                        name="month"
                        min="1"
                        max="12"
                        validate={composeField(numeric, range(1, 12))}
                        render={TextInput}
                        placeholder="Exp. Month"
                        type="number"
                      />
                    </div>
                    <div className="col-sm-6">
                      <Field
                        name="year"
                        min={getCurrentYear()}
                        max={getYearsFromNow(6)}
                        validate={composeField(
                          numeric,
                          range(getCurrentYear(), getYearsFromNow(6))
                        )}
                        render={TextInput}
                        placeholder="Exp. Year"
                        type="number"
                      />
                    </div>
                  </div>

                  <AddressFields
                    states={stateList(billingAddress.addressTypeId)()}
                  />
                </div>
                <div className="col-sm-12 text-center mt-4 mb-4 pb-4">
                  <FormErrors
                    submitError={submitError}
                    dirtySinceLastSubmit={dirtySinceLastSubmit}
                  />
                  <button
                    type="submit"
                    className="btn btn-primary btn-wide"
                    disabled={submitting}>
                    SAVE
                  </button>
                </div>
              </form>
            )}
          />
        );
      }}
    </Subscribe>
  );
};

export { PaymentMethodUpdate };
